<div class="modal-header blue">
  <h4 class="modal-title">Manage Filters</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<div class="modal-body">
  <form [formGroup]="formFiltersEditor">
    <ng-container
      *ngIf="quickFilterItems && quickFilterItems.length > 0; else emptyState"
    >
      <label>Default: </label>

      <section
        dndDropzone
        class="dropzone"
        (dndDrop)="onDropNewDefaultQuickFilter($event)"
        formArrayName="items"
      >
        <ng-container *ngFor="let item of quickFilterItems; let i = index">
          <div
            class="draggable"
            [dndDraggable]="item"
            [dndEffectAllowed]="draggable.effectAllowed"
            [dndDisableIf]="draggable.disable"
            [ngbTooltip]="getValidationMessage(i)"
            tooltipClass="tooltip-error"
            [disableTooltip]="
              !formArrayItems.at(i).invalid && !isControlValueNotUnique(i)
            "
            *ngIf="item.default && i === 0"
          >
            <div dndHandle class="draggable-handle">
              <i class="fas fa-bars"></i>
            </div>

            <input
              type="text"
              [class]="
                'input' +
                (isControlValueNotUnique(i) ? ' ng-invalid ng-touched' : '')
              "
              [value]="item.name"
              [formControlName]="i"
            />

            <!-- <div class="invalid-feedback d-block text-left" *ngIf="formArrayItems.at(i).invalid || isControlValueNotUnique(i)">
                <span *ngIf="formArrayItems.at(i).errors?.required">This field is required</span>
                <span *ngIf="formArrayItems.at(i).errors?.minlength">
                  Min length: {{formArrayItems.at(i).errors.minlength['requiredLength']}}
                </span>
                <span *ngIf="formArrayItems.at(i).errors?.maxlength">
                  Max length: {{formArrayItems.at(i).errors.maxlength['requiredLength']}}
                </span>
                <span *ngIf="isControlValueNotUnique(i)">Quick Filter name should be unique</span>
              </div> -->

            <a
              href="javascript:void(0)"
              (click)="deleteFilterItem(item, i)"
              class="draggable-delete"
            >
              <i class="fas fa-times-circle"></i>
            </a>
          </div>
        </ng-container>

        <div
          class="draggable-placeholder"
          *ngIf="!quickFilterItems[0]?.default"
        >
          Place default Quick Filter here
        </div>
      </section>

      <hr />

      <section
        dndDropzone
        class="dropzone mt-3"
        (dndDrop)="onDrop($event)"
        formArrayName="items"
      >
        <ng-container
          *ngFor="let item of quickFilterItems; let i = index; else"
        >
          <div
            class="draggable"
            [dndDraggable]="item"
            [dndEffectAllowed]="draggable.effectAllowed"
            [dndDisableIf]="draggable.disable"
            [ngbTooltip]="getValidationMessage(i)"
            tooltipClass="tooltip-error"
            [disableTooltip]="
              !formArrayItems.at(i).invalid && !isControlValueNotUnique(i)
            "
            *ngIf="(!quickFilterItems[0]?.default && i === 0) || i > 0"
          >
            <div dndHandle class="draggable-handle">
              <i class="fas fa-bars"></i>
            </div>

            <input
              type="text"
              [class]="
                'input' +
                (isControlValueNotUnique(i) ? ' ng-invalid ng-touched' : '')
              "
              [value]="item.name"
              [formControlName]="i"
            />

            <!-- <div class="invalid-feedback d-block text-left" *ngIf="formArrayItems.at(i).invalid || isControlValueNotUnique(i)">
                <span *ngIf="formArrayItems.at(i).errors?.required">This field is required</span>
                <span *ngIf="formArrayItems.at(i).errors?.minlength">
                  Min length: {{formArrayItems.at(i).errors.minlength['requiredLength']}}
                </span>
                <span *ngIf="formArrayItems.at(i).errors?.maxlength">
                  Max length: {{formArrayItems.at(i).errors.maxlength['requiredLength']}}
                </span>
                <span *ngIf="isControlValueNotUnique(i)">Quick Filter name should be unique</span>
              </div> -->

            <a
              href="javascript:void(0)"
              (click)="deleteFilterItem(item, i)"
              class="draggable-delete"
            >
              <i class="fas fa-times-circle"></i>
            </a>
          </div>
        </ng-container>

        <div
          dndPlaceholderRef
          class="draggable-placeholder"
          [ngStyle]="
            notDefaultDNDPlaceholderIsHidden ? { display: 'none' } : {}
          "
        >
          Place element here
        </div>

        <div
          class="draggable-placeholder"
          *ngIf="quickFilterItems?.length === 1 && quickFilterItems[0].default"
        >
          Place element here
        </div>
      </section>
    </ng-container>

    <ng-template #emptyState>
      <empty-state title="No Quick Filters Yet"></empty-state>
    </ng-template>
  </form>
</div>

<div class="modal-footer">
  <button
    class="button-outline w-100px"
    [disabled]="
      !currentFiltersFormValues || newFilterName || !isAddQuickFilterEnabled
    "
    (click)="addNewFilter()"
  >
    Add Filter
  </button>

  <button
    type="submit"
    class="button w-80px"
    [disabled]="!formFiltersEditor.valid"
    (click)="doSave()"
  >
    Save
  </button>
</div>
